import { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { API } from "../App";
import axios from "axios";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function EmailVerifyPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${API}/auth/verify-email/${token}`);
        setStatus("success");
        setMessage(response.data.message || "Email verified successfully!");
      } catch (error) {
        setStatus("error");
        setMessage(error.response?.data?.detail || "Verification failed. The link may have expired.");
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="email-verify-page">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {status === "verifying" && (
          <>
            <Loader2 className="w-16 h-16 mx-auto text-[#2BAEE5] animate-spin mb-6" />
            <h1 className="text-2xl font-bold text-[#0F172A] mb-2" style={{ fontFamily: 'Barlow Condensed' }}>
              VERIFYING EMAIL
            </h1>
            <p className="text-slate-600">Please wait while we verify your email address...</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircle className="w-16 h-16 mx-auto text-green-500 mb-6" />
            <h1 className="text-2xl font-bold text-[#0F172A] mb-2" style={{ fontFamily: 'Barlow Condensed' }}>
              EMAIL VERIFIED!
            </h1>
            <p className="text-slate-600 mb-6">{message}</p>
            <Button 
              onClick={() => navigate("/login")}
              className="w-full bg-[#7C2C3B] hover:bg-[#63232F]"
            >
              CONTINUE TO LOGIN
            </Button>
          </>
        )}

        {status === "error" && (
          <>
            <XCircle className="w-16 h-16 mx-auto text-red-500 mb-6" />
            <h1 className="text-2xl font-bold text-[#0F172A] mb-2" style={{ fontFamily: 'Barlow Condensed' }}>
              VERIFICATION FAILED
            </h1>
            <p className="text-slate-600 mb-6">{message}</p>
            <div className="space-y-3">
              <Button 
                onClick={() => navigate("/profile")}
                className="w-full bg-[#7C2C3B] hover:bg-[#63232F]"
              >
                REQUEST NEW LINK
              </Button>
              <Link to="/" className="block text-sm text-slate-500 hover:text-[#2BAEE5]">
                Return to Home
              </Link>
            </div>
          </>
        )}

        {/* West Ham branding */}
        <div className="mt-8 pt-6 border-t border-slate-200">
          <Link to="/" className="flex items-center justify-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[#7C2C3B] flex items-center justify-center">
              <span className="text-white font-bold text-sm" style={{ fontFamily: 'Barlow Condensed' }}>ALL</span>
            </div>
            <span className="text-[#0F172A] font-bold" style={{ fontFamily: 'Barlow Condensed' }}>ALL WHUFC</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
